export const SENSOR_BRANDS_FETCH_STARTED = 'SENSOR_BRANDS_FETCH_STARTED';
export const SENSOR_BRANDS_FETCH_COMPLETED = 'SENSOR_BRANDS_FETCH_COMPLETED';
export const SENSOR_BRANDS_FETCH_FAILED = 'SENSOR_BRANDS_FETCH_FAILED';
